import React, { useState, useRef, useEffect, CSSProperties, DetailedHTMLProps, HTMLAttributes } from "react";
import { UserProfile } from "../../types";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faDesktop, faHome, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import "./styles.scss"

interface UserBadgeProps {
    user: UserProfile;
    propStyles?: Object
}

const UserBadge: React.FC<UserBadgeProps> = ({ user, propStyles }) => {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const { logout, roles, featureToggles } = useAuth();
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [location]);


    const initials = user.name
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div style={{ ...styles.container, ...propStyles }} ref={menuRef}>
            <div style={styles.badge} onClick={() => setOpen(!open)}>
                <div style={styles.circle}>{initials}</div>
                <span className="user-name">{user.name}</span>
                <span style={{ marginLeft: 6 }}><FontAwesomeIcon icon={faChevronDown} /></span>
            </div>

            {open && (
                <div style={styles.menu}>
                    {location.pathname !== "/painel-central/dashboard" && (
                        <div style={styles.menuItem} onClick={() => navigate("/painel-central/dashboard")}>
                            <FontAwesomeIcon icon={faHome} /> Home
                        </div>
                    )}

                    {
                        featureToggles.filter(obj => obj.nome === "Painel Admin").length > 0 && <div style={styles.menuItem} onClick={() => navigate("/painel-central/admin-panel")}>
                            <FontAwesomeIcon icon={faDesktop} /> Painel administrativo
                        </div>
                    }

                    <div style={styles.menuItem} onClick={logout}>
                        <FontAwesomeIcon icon={faPowerOff} /> Sair
                    </div>
                </div>
            )}
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    container: {
        position: "relative",
        display: "inline-block",
    },
    badge: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        padding: "4px 8px",
        borderRadius: "6px",
        transition: "background 0.2s",
    },
    circle: {
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        backgroundColor: "#ED1C24",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "14px",
    },
    menu: {
        position: "absolute",
        right: 0,
        top: "110%",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        overflow: "hidden",
        minWidth: "180px",
        zIndex: 100,
    },
    menuItem: {
        padding: "10px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        color: "#333",
        transition: "background 0.2s",
    },
};

export default UserBadge;
